import React from 'react';
import Content from '../Content/Content';
import ScrollAnimation from 'react-animate-on-scroll';
import Grid from '../Grid-View/Grid-View';
import rest from './rest.jpg';

const Restaurant = () => {
    return (
        <Content>
            <div>
                <ScrollAnimation animateIn="fadeInDown" animateOnce="true">
                    <h1 style={{marginBottom: '3em'}}>Restauracja Stara Wozownia</h1>
                </ScrollAnimation>
                <Grid fnot="false" strona="prawa" zdj={rest}><p className="restp">Restauracja „Stara Wozownia” słynie z wyśmienitej i różnorodnej kuchni według własnej koncepcji kulinarnej – serwujemy dania kuchni polskiej i śródziemnomorskiej. Jesteśmy znani i doceniani w okolicy za nasze zupy, dania z wołowiny, oraz najlepszą kaczkę w Wielkopolsce.
<br/>
Kuchnia polska w naszej wersji charakteryzuje się z jednej strony zachowaniem oryginalnych, tradycyjnych domowych przepisów, a z drugiej – serwujemy ją w nowym, zdrowym wydaniu. Produkty wykorzystywane przez szefa kuchni pochodzą zawsze ze znanych i sprawdzonych źródeł dzięki czemu możemy zaoferować własne wypieki, pasztety czy smalec. Z kolei kuchnia śródziemnomorska to całe bogactwo potraw z Włoch, Francji i Hiszpanii bazujących na rybach, owocach morza, makaronach, świeżych warzywach serwowanych w daniach głównych, przystawkach czy sałatkach.  
<br/>
Każdy z Państwa znajdzie w naszej restauracji swój smak.  
<br/>
Dla gości Willi Stara Wozownia przygotowujemy śniadania kontynentalne, zarówno z regionalnych produktów jak i z oryginalnych włoskich wędlin i serów.</p></Grid>
            </div>
        </Content>
    )
}

export default Restaurant;


// WEBPACK FOOTER //
// ./src/Restaurant/Restaurant.js